import Banner from "./sections/Banner.js";
import Thesis from "./sections/Thesis.js";
import Building from "./sections/Building.js";
import Footer from "./sections/Footer";

function App() {
  return (
    <main className='font-body bg-background min-h-screen'>
      <div className='max-w-screen-xl mx-auto px-6 sm:px-10 lg:px-16'>
        <Banner />
        <Thesis />
        <Building />
        <Footer />
      </div>
    </main>
  );
}

export default App;
